const {track,clamp}=require('./scroll-driver.js');
const {enabled}=require('./transition.js');
document.querySelectorAll('[data-immersive-hero]').forEach(hero=>{
 const art=hero.querySelector('[data-hero-scene]');
 if(!art)return;
 track(hero,data=>{
  const progress=clamp(-data.top/Math.max(1,data.height));
  hero.style.setProperty('--hero-turn',`${progress*18}deg`);
  hero.style.setProperty('--hero-lift',`${progress*-70}px`);
 },()=>hero.getBoundingClientRect(),()=>{
  ['--hero-turn','--hero-lift'].forEach(name=>hero.style.removeProperty(name));
 });
 let frame=0,x=0,y=0;
 const paint=()=>{frame=0;art.style.setProperty('--pointer-x',String(x));art.style.setProperty('--pointer-y',String(y));};
 const reset=()=>{cancelAnimationFrame(frame);frame=0;x=0;y=0;paint();};
 hero.addEventListener('pointermove',event=>{
  if(event.pointerType!=='mouse'||!enabled())return;
  const rect=art.getBoundingClientRect();
  x=clamp((event.clientX-rect.left)/rect.width)-.5;
  y=clamp((event.clientY-rect.top)/rect.height)-.5;
  if(!frame)frame=requestAnimationFrame(paint);
 });
 hero.addEventListener('pointerleave',reset);
 addEventListener('onestep:motion',reset);
 if(enabled())art.querySelectorAll('[data-hero-frame]').forEach((element,index)=>{
  const animation=element.animate([{opacity:.25,clipPath:'inset(12% 0 0)'},{opacity:1,clipPath:'inset(0)'}],{duration:850,delay:index*60,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
  addEventListener('onestep:motion',()=>{if(!enabled())animation.cancel();});
 });
});
